
export const cityStateList=[
    {
    "MANIPUR":{
        "city":[{
                 "name":"UKHRUL"
                 },
                 {
                 "name":"THOUBAL"
                 }
                 ,
                 {
                 "name":"TAMENGLONG"
                 }
                 ,
                 {
                 "name":"SUGNU"
                 },
                 {
                 "name":"SENAPATI"
                 },
                 {
                 "name":"MOREH"
                 },
                 {
                 "name":"MOIRANG"
                 }
                 ,
                 {
                 "name":"MAYANG"
                 }
                 ,
                 {
                 "name":"IMPHAL"
                 }
                 ,
                 {
                 "name":"JIRIBAM"
                 }
                 ,
                 {
                 "name":"IMPHAL"
                 }
                 ,
                {
                 "name":"CHURACHANDPUR"
                 }
                 ,
                 {
                 "name":"CHANDEL"
                 }
                 ,
                 {
                 "name":"BISHENPUR"
                 }
               ]
             }
            },
             
    {"GUJARAT":{
        "city":[{
                 "name":"WANKANER"
                 },
                 {
                 "name":"VYARA"
                 }
                 ,
                 {
                 "name":"VISNAGAR"
                 }
                 ,
                 {
                 "name":"VISAVADAR"
                 },
                 {
                 "name":"VIRAMGAM"
                 },
                 {
                 "name":"VIJAPUR"
                 },
                 {
                 "name":"VERAVAL"
                 }
                 ,
                 {
                 "name":"VEJALPUR"
                 }
                 ,
                 {
                 "name":"VARTEJ"
                 }
                 ,
                 {
                 "name":"VAPI"
                 }
                 ,
                 {
                 "name":"VANSDA"
                 }
                 ,
                {
                 "name":"VALSAD"
                 }
                 ,
                 {
                 "name":"VADODARA"
                 }
                 ,
                 {
                 "name":"VADIA"
                 },
                 {
                 "name":"UPLETA"
                 }
                 ,
                 {
                 "name":"UNJHA"
                 }
                 ,
                 {
                 "name":"UNA"
                 },
                 {
                 "name":"UMRETH"
                 },
                 {
                 "name":"UMARGAM"
                 },
                 {
                 "name":"THE DANGS"
                 }
                 ,
                 {
                 "name":"THARAD"
                 }
                 ,
                 {
                 "name":"THANGADH"
                 }
                 ,
                 {
                 "name":"TALOD"
                 }
                 ,
                 {
                 "name":"TALAJA"
                 }
                 ,
                {
                 "name":"SURENDRANAGAR"
                 }
                 ,
                 {
                 "name":"SURAT"
                 }
                 ,
                 {
                 "name":"SONGADH"
                 }
                 ,
                 {
                 "name":"SILVASSA"
                 },
                 {
                 "name":"SIHOR"
                 }
                 ,
                 {
                 "name":"SIDDPUR"
                 }
                 ,
                 {
                 "name":"SAYAN"
                 }
                 ,
                 {
                 "name":"SAVARKUNDLA"
                 }
                 ,
                 {
                 "name":"SATLASANA"
                 }
                 ,
                {
                 "name":"SANTRAMPUR"
                 }
                 ,
                 {
                 "name":"SANKHEDA"
                 }
                 ,
                 {
                 "name":"SANAND"
                 }
                 ,
                 {
                 "name":"SALAYA"
                 }
                 ,
                 {
                 "name":"RANOLI"
                 },
                 {
                 "name":"RAMOL"
                 }
                 ,
                 {
                 "name":"RAJULA"
                 }
                 ,
                 {
                 "name":"RAJPIPLA"
                 }
                 ,
                 {
                 "name":"RAJKOT"
                 }
                 ,
                 {
                 "name":"PRANTIJ"
                 }
                 ,
                {
                 "name":"PORBANDAR"
                 }
                 ,
                 {
                 "name":"PATAN"
                 }
                 ,
                 {
                 "name":"PALGHAT"
                 }
                 ,
                 {
                 "name":"PALEJ"
                 }
                 ,
                 {
                 "name":"PALANPUR"
                 }
                 ,
                 {
                 "name":"ODE"
                 }
                 ,
                 {
                 "name":"NAVSARI"
                 },
                 {
                 "name":"NANDEJ"
                 }
                 ,
                 {
                 "name":"NADIAD"
                 }
                 ,
                 {
                 "name":"MUNDRA"
                 }
                 ,
                 {
                 "name":"MORBI"
                 }
                 ,
                 {
                 "name":"MODASA"
                 }
                 ,
                {
                 "name":"MITHAPUR"
                 }
                 ,
                 {
                 "name":"MEHSANA"
                 }
                 ,
                 {
                 "name":"MEGHRAJ"
                 }
                 ,
                {
                 "name":"MANSA"
                 }
                 ,
                 {
                 "name":"MANGROL"
                 }
                 ,
                 {
                 "name":"MANDVI"
                 }
                 ,
                 {
                 "name":"KUTCH"
                 }
                 ,
                 {
                 "name":"MANDVI"
                 }
                 ,
                 {
                 "name":"MALPUR"
                 }
                 ,
                 {
                 "name":"MAHUDHA"
                 },
                 {
                 "name":"LUNAVADA"
                 }
                 ,
                 {
                 "name":"LIMBDI"
                 }
                 ,
                 {
                 "name":"LATHI"
                 }
                 ,
                 {
                 "name":"KUTCH"
                 }
                 ,
                 {
                 "name":"KOTHAMANGALAM"
                 }
                 ,
                {
                 "name":"KOSAMBA"
                 }
                 ,
                 {
                 "name":"KHERALU"
                 }
                 ,
                 {
                 "name":"KHEDA"
                 }
                 ,
                 {
                 "name":"KHAMBHAT"
                 }
                 ,
                 {
                 "name":"KHAMBHALIA"
                 }
                 ,
                 {
                 "name":"KESHOD"
                 }
                 ,
                 {
                 "name":"KARJAN"
                 },
                 {
                 "name":"KAPADWANJ"
                 }
                 ,
                 {
                 "name":"KANPUR"
                 }
                 ,
                 {
                 "name":"KANODAR"
                 }
                 ,
                 {
                 "name":"KALAVAD"
                 }
                 ,
                 {
                 "name":"KADI"
                 }
                 ,
                {
                 "name":"JUNAGADH"
                 }
                 ,
                 {
                 "name":"JETPUR"
                 }
                 ,
                 {
                 "name":"JASDAN"
                 }
                 ,
                {
                 "name":"JAMNAGAR"
                 }
                 ,
                 {
                 "name":"JAMBUSAR"
                 }
                 ,
                 {
                 "name":"JAM"
                 }
                 ,
                 {
                 "name":"JODHPUR"
                 }
                 ,
                 {
                 "name":"JALALPORE"
                 }
                 ,
                 {
                 "name":"JAFRABAD"
                 }
                 ,
                 {
                 "name":"IDAR"
                 },
                 {
                 "name":"HIMATNAGAR"
                 }
                 ,
                 {
                 "name":"HARIJ"
                 }
                 ,
                 {
                 "name":"HALVAD"
                 }
                 ,
                 {
                 "name":"HALOL"
                 }
                 ,
                 {
                 "name":"GONDAL"
                 }
                 ,
                {
                 "name":"GODHARA"
                 }
                 ,
                 {
                 "name":"GANDHINAGAR"
                 }
                 ,
                 {
                 "name":"GANDEVI"
                 }
                 ,
                 {
                 "name":"DOHAD"
                 }
                 ,
                 {
                 "name":"DIGVIJAYGRAM"
                 }
                 ,
                 {
                 "name":"DHROL"
                 }
                 ,
                 {
                 "name":"DHRANGADHRA"
                 }
                 ,
                 {
                 "name":"DHOLKA"
                 }
                 ,
                 {
                 "name":"DHOLA"
                 },
                 {
                 "name":"DHARAMPUR"
                 }
                 ,
                 {
                 "name":"DHANERA"
                 }
                 ,
                 {
                 "name":"DHANDHUKA"
                 }
                 ,
                 {
                 "name":"DEVSAR"
                 }
                 ,
                 {
                 "name":"DEVGADH"
                 }
                 ,
                {
                 "name":"BARIA"
                 }
                 ,
                 {
                 "name":"DEESA"
                 }
                 ,
                 {
                 "name":"DAMNAGAR"
                 }
                 ,
                 {
                 "name":"DAMAN"
                 }
                 ,
                 {
                 "name":"DAHOD"
                 }
                 ,
                 {
                 "name":"DAHEGAM"
                 }
                 ,
                 {
                 "name":"DABHOI"
                 }
                 ,
                 {
                 "name":"CHORVAD"
                 }
                 ,
                 {
                 "name":"CHIKHLI"
                 }
                 ,
                 {
                 "name":"CHHAYA"
                 }
                 ,
                 {
                 "name":"CHANASMA"
                 },
                 {
                 "name":"CHALTHAN"
                 }
                 ,
                 {
                 "name":"CHALALA"
                 }
                 ,
                 {
                 "name":"CHAKLASI"
                 }
                 ,
                 {
                 "name":"BORSAD"
                 }
                 ,
                 {
                 "name":"BORIAVI"
                 }
                 ,
                {
                 "name":"BODELI"
                 }
                 ,
                 {
                 "name":"BHUJ"
                 }
                 ,
                 {
                 "name":"BHAYAVADAR"
                 }
                  ,
                 {
                 "name":"BHAVNAGAR"
                 }
                 ,
                 {
                 "name":"BHARUCH"
                 }
                 ,
                 {
                 "name":"BHACHAU"
                 }
                 ,
                 {
                 "name":"BECHARAJI"
                 }
                 ,
                 {
                 "name":"BAYAD"
                 }
                 ,
                 {
                 "name":"BAVLA"
                 }
                 ,
                 {
                 "name":"BARODA"
                 }
                 ,
                 {
                 "name":"BARDOLI"
                 }
                 ,
                 {
                 "name":"BALASINOR"
                 },
                 {
                 "name":"BAGASARA"
                 }
                 ,
                 {
                 "name":"BABRA"
                 }
                 ,
                 {
                 "name":"ATUL"
                 }
                 ,
                 {
                 "name":"ANKLESHWAR"
                 }
                 ,
                 {
                 "name":"ANJAR"
                 }
                 ,
                {
                 "name":"ANDADA"
                 }
                 ,
                 {
                 "name":"ANAND"
                 }
                 ,
                 {
                 "name":"AMRELI"
                 }
                 ,
                {
                 "name":"AMBAJI"
                 }
                 ,
                 {
                 "name":"AHMEDABAD"
                 }
                 ,
                 {
                 "name":"ABRAMA"
                 } 
               ]
             }},
     
     {"KARNATAKA":{
        "city":[{
                 "name":"ZAHIRABAD"
                 },
                 {
                 "name":"YELBARGA"
                 }
                 ,
                 {
                 "name":"YELANDUR"
                 }
                 ,
                 {
                 "name":"YADGIR"
                 },
                 {
                 "name":"VIRAJPET"
                 },
                 {
                 "name":"VIJAYAPURA"
                 },
                 {
                 "name":"VENKATAPURA"
                 }
                 ,
                 {
                 "name":"URVAKONDA"
                 }
                 ,
                 {
                 "name":"ULLAL"
                 }
                 ,
                 {
                 "name":"UDUPI"
                 }
                 ,
                 {
                 "name":"TURUVEKERE"
                 }
                 ,
                {
                 "name":"TUMKUR"
                 }
                 ,
                 {
                 "name":"TORANAGALLU"
                 }
                 ,
                 {
                 "name":"TIRUMAKUDAL NARSIPUR"
                 },
                 {
                 "name":"TIRTHAHALLI"
                 },
                 {
                 "name":"TIPTUR"
                 }
                 ,
                 {
                 "name":"THUMBE"
                 }
                 ,
                 {
                 "name":"TERDAL"
                 },
                 {
                 "name":"TEKKALAKOTA"
                 },
                 {
                 "name":"TARIKERE"
                 },
                 {
                 "name":"TALIKOTI"
                 }
                 ,
                 {
                 "name":"SUPA"
                 }
                 ,
                 {
                 "name":"SULLIA"
                 }
                 ,
                 {
                 "name":"SRINIVASPUR"
                 }
                 ,
                 {
                 "name":"SRINIVASNAGAR"
                 }
                 ,
                {
                 "name":"SRINGERI"
                 }
                 ,
                 {
                 "name":"SORAB"
                 }
                 ,
                 {
                 "name":"SOMVARPET"
                 }
                 ,
                 {
                 "name":"SIRVAR"
                 }
                 ,
                 {
                 "name":"SIRUGUPPA"
                 },
                 {
                 "name":"SIRSI"
                 },
                 {
                 "name":"SIRA"
                 }
                 ,
                 {
                 "name":"SINDHNUR"
                 }
                 ,
                 {
                 "name":"SINDHANUR"
                 },
                 {
                 "name":"SINDGI"
                 },
                 {
                 "name":"SIDDAPUR"
                 },
                 {
                 "name":"SHORAPUR"
                 }
                 ,
                 {
                 "name":"SHIRHATTI"
                 }
                 ,
                 {
                 "name":"SHIMOGA"
                 }
                 ,
                 {
                 "name":"SHIGGAON"
                 }
                 ,
                 {
                 "name":"SHAKTINAGAR"
                 }
                 ,
                {
                 "name":"SHAHAPUR"
                 }
                 ,
                 {
                 "name":"SEDAM"
                 }
                 ,
                 {
                 "name":"SAVANUR"
                 }
                 ,
                 {
                 "name":"SAUNDATTI"
                 },
                 {
                 "name":"SANDUR"
                 }
                 ,
                 {
                 "name":"SALIGRAM"
                 }
                 ,
                 {
                 "name":"SAKLESHPUR"
                 },
                 {
                 "name":"SAIDAPUR"
                 },
                 {
                 "name":"SAGAR"
                 },
                 {
                 "name":"RON"
                 }
                 ,
                 {
                 "name":"RAYADURG"
                 }
                 ,
                 {
                 "name":"RANIBENNUR"
                 }
                 ,
                 {
                 "name":"RANEBENNUR"
                 }
                 ,
                 {
                 "name":"RAMANAGARAM"
                 }
                 ,
                {
                 "name":"RAMANAGARA"
                 }
                 ,
                 {
                 "name":"RAICHUR"
                 }
                 ,
                 {
                 "name":"RAIBAG"
                 },
                 {
                 "name":"PUTTUR"
                 },
                 {
                 "name":"PUDU"
                 }
                 ,
                 {
                 "name":"PIRIYAPATNA"
                 }
                 ,
                 {
                 "name":"PAVAGADA"
                 },
                 {
                 "name":"PANDAVAPURA"
                 },
                 {
                 "name":"PALGHAT"
                 },
                 {
                 "name":"NORTH KARNATAKA"
                 }
                 ,
                 {
                 "name":"NIPANI"
                 }
                 ,
                 {
                 "name":"NAVALGUND"
                 }
                 ,
                 {
                 "name":"NAREGAL"
                 }
                 ,
                 {
                 "name":"NALGONDA"
                 }
                 ,
                {
                 "name":"MYSORE"
                 }
                 ,
                 {
                 "name":"MUNDGOD"
                 }
                 ,
                 {
                 "name":"MUNDARGI"
                 }
                 ,
                 {
                 "name":"MULGUND"
                 }
                 ,
                 {
                 "name":"MULBAGAL"
                 },
                 {
                 "name":"MUDIGERE"
                 },
                 {
                 "name":"MUDHOL"
                 }
                 ,
                 {
                 "name":"MUDGAL"
                 }
                 ,
                 {
                 "name":"MUDDEBIHAL"
                 },
                 {
                 "name":"MOODBIDRI"
                 },
                 {
                 "name":"MANVI"
                 },
                 {
                 "name":"MANGALORE"
                 }
                 ,
                 {
                 "name":"MANDYA"
                 }
                 ,
                 {
                 "name":"MALUR"
                 }
                 ,
                 {
                 "name":"MALAVALLI"
                 }
                 ,
                 {
                 "name":"MAGADI"
                 }
                 ,
                {
                 "name":"MADIKERI"
                 }
                 ,
                 {
                 "name":"MADHUGIRI"
                 }
                 ,
                 {
                 "name":"MADDUR"
                 }
                 ,{
                 "name":"LONDA"
                 },
                 {
                 "name":"LINGSUGUR"
                 },
                 {
                 "name":"LAKSHMESHWAR"
                 }
                 ,
                 {
                 "name":"KUSHTAGI"
                 }
                 ,
                 {
                 "name":"KUSHALNAGAR"
                 },
                 {
                 "name":"KURNOOL"
                 },
                 {
                 "name":"KUNIGAL"
                 },
                 {
                 "name":"KUNDGOL"
                 }
                 ,
                 {
                 "name":"KUNDAPURA"
                 }
                 ,
                 {
                 "name":"KUMTA"
                 }
                 ,
                 {
                 "name":"KUDREMUKH"
                 }
                 ,
                 {
                 "name":"KUDCHI"
                 }
                 ,
                {
                 "name":"KRISHNARAJPET"
                 }
                 ,
                 {
                 "name":"KRISHNARAJASAGARA"
                 }
                 ,
                 {
                 "name":"KRISHNARAJANAGARA"
                 }
                 ,
                 {
                 "name":"KORATAGERE"
                 },
                 {
                 "name":"KOPPAL"
                 }
                 ,
                 {
                 "name":"KOPPA"
                 }
                 ,
                 {
                 "name":"KONNUR"
                 },
                 {
                 "name":"KOLLEGAL"
                 },
                 {
                 "name":"KOLAR GOLD FIELD"
                 },
                 {
                 "name":"KOLAR"
                 }
                 ,
                 {
                 "name":"KODURU"
                 }
                 ,
                 {
                 "name":"KODIGENAHALLI"
                 }
                 ,
                 {
                 "name":"KHANAPUR"
                 }
                 ,
                 {
                 "name":"KERUR"
                 }
                 ,
                {
                 "name":"KARWAR"
                 }
                 ,
                 {
                 "name":"KARIMNAGAR"
                 }
                 ,
                 {
                 "name":"KANNUR"
                 },
                 {
                 "name":"KALGHATGI"
                 },
                 {
                 "name":"KAIGA"
                 }
                 ,
                 {
                 "name":"KADUR"
                 }
                 ,
                 {
                 "name":"KADRA"
                 },
                 {
                 "name":"JEVARGI"
                 },
                 {
                 "name":"JAMKHANDI"
                 },
                 {
                 "name":"JAGALUR"
                 }
                 ,
                 {
                 "name":"INDI"
                 }
                 ,
                 {
                 "name":"ILKAL"
                 }
                 ,
                 {
                 "name":"HUNSUR"
                 }
                 ,
                 {
                 "name":"HUNGUND"
                 }
                 ,
                {
                 "name":"HUMNABAD"
                 }
                 ,
                 {
                 "name":"HUBLI"
                 }
                 ,
                 {
                 "name":"HOSPET"
                 }
                 ,
                 {
                 "name":"HOSKOTE"
                 }
                 ,
                 {
                 "name":"HOSANAGARA"
                 },
                 {
                 "name":"HOSADURGA"
                 },
                 {
                 "name":"HONNALI"
                 }
                 ,
                 {
                 "name":"HONAWAR"
                 }
                 ,
                 {
                 "name":"HOMNABAD"
                 },
                 {
                 "name":"HOLENARASIPUR"
                 },
                 {
                 "name":"HOLE NARSIPUR"
                 },
                 {
                 "name":"HOLALKERE"
                 }
                 ,
                 {
                 "name":"HIRIYUR"
                 }
                 ,
                 {
                 "name":"HIREKERUR"
                 }
                 ,
                 {
                 "name":"HEGGADADEVANKOTE"
                 }
                 ,
                 {
                 "name":"HEBBALU"
                 }
                 ,
                {
                 "name":"HAVERI"
                 }
                 ,
                 {
                 "name":"HASSAN"
                 }
                 ,
                 {
                 "name":"HARIHAR"
                 }
                 ,
                 {
                 "name":"HARAPANAHALLI"
                 }
                 ,
                 {
                 "name":"HANGAL"
                 }
                 ,
                 {
                 "name":"HAGARIBOMMANAHALLI"
                 },
                 {
                 "name":"HADAGALLI"
                 },
                 {
                 "name":"GUNDLUPET"
                 }
                 ,
                 {
                 "name":"GULBARGA"
                 }
                 ,
                 {
                 "name":"GUBBI"
                 },
                 {
                 "name":"GONIKOPPAL"
                 },
                 {
                 "name":"GOKARNA"
                 },
                 {
                 "name":"GOKAK"
                 }
                 ,
                 {
                 "name":"GAURIBIDANUR"
                 }
                 ,
                 {
                 "name":"GANGAWATI"
                 }
                 ,
                 {
                 "name":"GANGAVATHI"
                 }
                 ,
                 {
                 "name":"GAJENDRAGARH"
                 }
                 ,
                {
                 "name":"GADAG"
                 }
                 ,
                 {
                 "name":"DODDABALLAPUR"
                 }
                 ,
                 {
                 "name":"DOD BALLAPUR"
                 }
                 ,
                 {
                 "name":"DHARWAR"
                 }
                 ,
                 {
                 "name":"DHARWAD"
                 }
                 ,
                 {
                 "name":"DEVANAHALLI"
                 }
                 ,
                 {
                 "name":"DEVADURGA"
                 }
                 ,
                {
                 "name":"DAVANGERE"
                 }
                 ,
                 {
                 "name":"DAVANAGERE"
                 }
                 ,
                 {
                 "name":"CUDDAPAH"
                 }
                 ,
                 {
                 "name":"CHITRADURGA"
                 }
                 ,
                 {
                 "name":"CHITAPUR"
                 }
                 ,
                 {
                 "name":"CHINTAMANI"
                 },
                 {
                 "name":"CHINCHOLI"
                 },
                 {
                 "name":"CHIKODI"
                 }
                 ,
                 {
                 "name":"CHIKNAYAKANHALLI"
                 }
                 ,
                 {
                 "name":"CHIKMAGALUR"
                 },
                 {
                 "name":"CHIKKABALLAPUR"
                 },
                 {
                 "name":"CHIKAMANGALUR"
                 },
                 {
                 "name":"CHIK BALLAPUR"
                 }
                 ,
                 {
                 "name":"CHANNARAYAPATNA"
                 }
                 ,
                 {
                 "name":"CHANNAPATNA"
                 }
                 ,
                 {
                 "name":"CHANNAGIRI"
                 }
                 ,
                 {
                 "name":"CHAMARAJANAGAR"
                 }
                 ,
                {
                 "name":"CHALLAKERE"
                 }
                 ,
                 {
                 "name":"BYNDOOR"
                 }
                 ,
                 {
                 "name":"BYADGI"
                 }
                 ,
                 {
                 "name":"BRAHMAVAR"
                 },
                 {
                 "name":"BILGI"
                 }
                 ,
                 {
                 "name":"BILAGI"
                 }
                 ,
                 {
                 "name":"BIJAPUR KA"
                 }
                 ,
                 {
                 "name":"BIJAPUR"
                 }
                 ,
                 {
                 "name":"BIDAR"
                 }
                 ,
                {
                 "name":"BIDADI"
                 }
                 ,
                 {
                 "name":"BHATKAL"
                 }
                 ,
                 {
                 "name":"BHALKI"
                 }
                 ,
                 {
                 "name":"BHADRAVATI"
                 }
                 ,
                 {
                 "name":"BELUR"
                 }
                 ,
                 {
                 "name":"BELTHANGADY"
                 },
                 {
                 "name":"BELLARY"
                 },
                 {
                 "name":"BELGAUM"
                 }
                 ,
                 {
                 "name":"BASAVANA BAGEVADI"
                 }
                 ,
                 {
                 "name":"BASAVAKALYAN"
                 },
                 {
                 "name":"BANTWAL"
                 },
                 {
                 "name":"BANNUR"
                 },
                 {
                 "name":"BANGARAPET"
                 }
                 ,
                 {
                 "name":"BANGALORE SOUTH"
                 }
                 ,
                 {
                 "name":"BANGALORE NORTH,"
                 }
                 ,
                 {
                 "name":"BANGALORE"
                 }
                 ,
                 {
                 "name":"BAJPE"
                 }
                 ,
                {
                 "name":"BAILHONGAL"
                 }
                 ,
                 {
                 "name":"BAGALKOT"
                 }
                 ,
                 {
                 "name":"BADAMI"
                 }
                 ,
                 {
                 "name":"B C ROAD"
                 }
                 ,
                 {
                 "name":"AURAD"
                 }
                 ,
                 {
                 "name":"ATHNI"
                 }
                 ,
                 {
                 "name":"ARSIKERE"
                 }
                 ,
                {
                 "name":"ARKALGUD"
                 }
                 ,
                 {
                 "name":"ANNIGERI"
                 }
                 ,
                 {
                 "name":"ANEKAL"
                 }
                 ,
                 {
                 "name":"ALUR"
                 }
                 ,
                 {
                 "name":"ALNAVAR"
                 }
                 ,
                 {
                 "name":"ALAND"
                 },
                 {
                 "name":"AFZALPUR"
                 },
                 {
                 "name":"ADYAR"
                 }		
               ]
             }},
                  
     {"GOA":{
        "city":[{
                 "name":"ZUARINAGAR"
                 },
                 {
                 "name":"VERNA"
                 }
                 ,
                 {
                 "name":"VASCO"
                 }
                 ,
                 {
                 "name":"VALPOI"
                 },
                 {
                 "name":"TIVIM"
                 },
                 {
                 "name":"SIOLIM"
                 },
                 {
                 "name":"SANVORDEM"
                 }
                 ,
                 {
                 "name":"SANGUEM"
                 }
                 ,
                 {
                 "name":"SADA"
                 }
                 ,
                 {
                 "name":"QUEULA"
                 }
                 ,
                 {
                 "name":"QUEPEM"
                 }
                 ,
                {
                 "name":"PORVORIM"
                 }
                 ,
                 {
                 "name":"PONDA"
                 }
                 ,
                 {
                 "name":"PERNEM"
                 },
                 {
                 "name":"PANJIM"
                 }
                 ,
                 {
                 "name":"PALE"
                 }
                 ,
                 {
                 "name":"ONDA I E"
                 }
                 ,
                {
                 "name":"NEURA"
                 }
                 ,
                 {
                 "name":"NERUL GOA"
                 }
                 ,
                 {
                 "name":"N B VEREM"
                 }
                 ,
                 {
                 "name":"MARGAO"
                 },
                 {
                 "name":"MARCEL"
                 },
                 {
                 "name":"MAPUSA"
                 }
                 ,
                 {
                 "name":"MAPUSA"
                 }
                 ,
                 {
                 "name":"GOA UNIVERSITY"
                 }
                 ,
                 {
                 "name":"GOA"
                 }
                 ,
                 {
                 "name":"CUROTORIM"
                 }
                 ,
                {
                 "name":"CUNDAIMIE"
                 }
                 ,
                 {
                 "name":"CORTALIM"
                 }
                 ,
                 {
                 "name":"CORLIN"
                 },
                 {
                 "name":"CORLIM"
                 }
                 ,
                 {
                 "name":"COLVALE"
                 }
                 ,
                 {
                 "name":"COLLEM"
                 }
                 ,
                {
                 "name":"CHINCHINIM"
                 }
                 ,
                 {
                 "name":"CHICALIM"
                 }
                 ,
                 {
                 "name":"CAVELOSSIM"
                 }
                  ,
                 {
                 "name":"CANDOLIM"
                 }
                 ,
                 {
                 "name":"CANACONA"
                 }
                 ,
                 {
                 "name":"CALANGUTE"
                 }
                 ,
                {
                 "name":"BOGMALO"
                 }
                 ,
                 {
                 "name":"BICHOLIM"
                 }
                 ,
                 {
                 "name":"BETUL GOA"
                 },
                 {
                 "name":"BETORAIE"
                 }
                 ,
                 {
                 "name":"BARDEZ"
                 }
                 ,
                 {
                 "name":"ASSONARA"
                 }
                 ,
                {
                 "name":"ASSOLNA"
                 }
                 ,
                 {
                 "name":"ARAMBOL"
                 }
                 ,
                 {
                 "name":"ANJUNA"
                 }
                 ,
                 {
                 "name":"ALDONA"
                 }
               ]
             }},
                  
     {"CHHATTISGARH":{
        "city":[{
                 "name":"TAKHATPUR"
                 },
                 {
                 "name":"SURAJPUR"
                 }
                 ,
                 {
                 "name":"SIMGA"
                 }
                 ,
                 {
                 "name":"SARANGARH"
                 },
                 {
                 "name":"SARAIPALI"
                 },
                 {
                 "name":"SAKTI"
                 },
                 {
                 "name":"RATANPUR"
                 }
                 ,
                 {
                 "name":"RAJNANDGAON"
                 }
                 ,
                 {
                 "name":"RAIPUR"
                 }
                 ,
                 {
                 "name":"RAIGARH"
                 }
                 ,
                 {
                 "name":"PENDRA"
                 }
                 ,
                {
                 "name":"PATAN"
                 }
                 ,
                 {
                 "name":"MUNGELI"
                 }
                 ,
                 {
                 "name":"MANENDRAGARH"
                 }
                 ,
                 {
                 "name":"MAHASAMUND"
                 }
                 ,
                 {
                 "name":"KURUD"
                 }
                 ,
                 {
                 "name":"KORBA"
                 }
                 ,
                 {
                 "name":"KONDAGAON"
                 }
                 ,
                {
                 "name":"KIRANDUL"
                 }
                 ,
                 {
                 "name":"KHARSIA"
                 }
                 ,
                 {
                 "name":"KHAROD"
                 }
                 ,
                {
                 "name":"PATAN"
                 }
                 ,
                 {
                 "name":"KHAIRAGARH"
                 }
                 ,
                 {
                 "name":"KAWARDHA"
                 }
                 ,
                 {
                 "name":"KATGHORA"
                 }
                 ,
                 {
                 "name":"KANKER"
                 }
                 ,
                 {
                 "name":"JASHPUR"
                 }
                 ,
                 {
                 "name":"JANJGIR CHAMPA"
                 }
                 ,
                {
                 "name":"JAGDALPUR"
                 }
                 ,
                 {
                 "name":"GHARGHODA"
                 }
                 ,
                 {
                 "name":"GEEDAM"
                 }
                  ,
                 {
                 "name":"DONGARGAON"
                 }
                 ,
                 {
                 "name":"DHAMTARI"
                 }
                 ,
                 {
                 "name":"DANTEWADA"
                 }
                 ,
                 {
                 "name":"CHAMPA"
                 }
                 ,
                 {
                 "name":"BILHA"
                 }
                 ,
                {
                 "name":"BILASPUR"
                 }
                 ,
                 {
                 "name":"BHILAIDURG"
                 }
                 ,
                 {
                 "name":"BHILAI"
                 }
                 ,
                {
                 "name":"BHATGAON"
                 }
                 ,
                 {
                 "name":"BHATAPARA"
                 }
                 ,
                 {
                 "name":"BHANPURI"
                 }
                 ,
                 {
                 "name":"BEMETARA"
                 }
                 ,
                 {
                 "name":"BALODA"
                 }
                 ,
                 {
                 "name":"BAIKUNTHPUR"
                 }
                 ,
                 {
                 "name":"ARANG"
                 }
                 ,
                {
                 "name":"AMBIKAPUR"
                 }
                 ,
                 {
                 "name":"AKALTARA"
                 }
                 ,
                 {
                 "name":"ABHANPUR"
                 }
               ]
             }},
                  
     {"PATNA":{
        "city":[{
                 "name":"DEVGARH"
                 }         
               ]
             }},
                  
     {"KERALA":{
        "city":[{
                 "name":"WAYANAD"
                 },
                 {
                 "name":"VARKALA"
                 }
                 ,
                 {
                 "name":"VARAM"
                 }
                 ,
                 {
                 "name":"VALLACHIRA"
                 },
                 {
                 "name":"VALAPATTANAM"
                 },
                 {
                 "name":"VAIKOM"
                 },
                 {
                 "name":"VADAKARA"
                 }
                 ,
                 {
                 "name":"UDMA"
                 }
                 ,
                 {
                 "name":"TRIVANDRUM"
                 }
                 ,
                 {
                 "name":"TRICHUR"
                 }
                 ,
                 {
                 "name":"TIRUR"
                 }
                 ,
                {
                 "name":"THIRUVANKULAM"
                 }
                 ,
                 {
                 "name":"THIRUVANATHAPURAM"
                 }
                 ,
                 {
                 "name":"THALASSERY"
                 }
                 ,
                 {
                 "name":"VARKALA"
                 }
                 ,
                 {
                 "name":"THAIKKAD"
                 }
                 ,
                 {
                 "name":"TALIPARAMBA"
                 },
                 {
                 "name":"RANNI"
                 },
                 {
                 "name":"QUILANDY"
                 },
                 {
                 "name":"PURANATTUKARA"
                 }
                 ,
                 {
                 "name":"POLLACHI"
                 }
                 ,
                 {
                 "name":"PERUMBAVOOR"
                 }
                 ,
                 {
                 "name":"PERUMBAIKAD"
                 }
                 ,
                 {
                 "name":"PERINTHALMANNA"
                 }
                 ,
                {
                 "name":"PATHANAMTHITTA"
                 }
                 ,
                 {
                 "name":"PAPPINISSERI"
                 }
                 ,
                 {
                 "name":"PALUVAI"
                 }
                  ,
                 {
                 "name":"PALLADAM"
                 }
                 ,
                 {
                 "name":"PALGHAT"
                 }
                 ,
                {
                 "name":"PALAYAD"
                 }
                 ,
                 {
                 "name":"PALAKKAD"
                 }
                 ,
                 {
                 "name":"PALAI"
                 }
                 ,
                 {
                 "name":"OTTAPALAM"
                 }
                 ,
                 {
                 "name":"OLAVANNA"
                 }
                 ,
                 {
                 "name":"NILAMBUR"
                 },
                 {
                 "name":"NEYYATTINKARA"
                 },
                 {
                 "name":"NEDUMANGAD"
                 },
                 {
                 "name":"NADATHARA"
                 }
                 ,
                 {
                 "name":"MUVATTUPUZHA"
                 }
                 ,
                 {
                 "name":"MULAVUKAD"
                 }
                 ,
                 {
                 "name":"MUHAMMA"
                 }
                 ,
                 {
                 "name":"MAVELIKARA"
                 }
                 ,
                {
                 "name":"MALAPURAM"
                 }
                 ,
                 {
                 "name":"MALAPPURAM"
                 }
                 ,
                 {
                 "name":"MADURAI"
                 }
                 ,
                 {
                 "name":"KUNNAMKULAM"
                 }
                 ,
                {
                 "name":"KOZHIKODE"
                 }
                 ,
                 {
                 "name":"KOTTAYAM"
                 }
                 ,
                 {
                 "name":"KOTHAMANGALAM"
                 }
                  ,
                 {
                 "name":"KOLLAM"
                 }
                 ,
                 {
                 "name":"KAYAMKULAM"
                 }
                 ,
                {
                 "name":"KASARGODE"
                 }
                 ,
                 {
                 "name":"KASARGOD"
                 }
                 ,
                 {
                 "name":"KASARAGOD"
                 }
                 ,
                 {
                 "name":"KANNUR"
                 }
                 ,
                 {
                 "name":"KANNADIPARAMBA"
                 }
                 ,
                 {
                 "name":"KALLIASSERI"
                 },
                 {
                 "name":"KALAMASSERY"
                 },
                 {
                 "name":"IRINJALAKUDA"
                 },
                 {
                 "name":"IDUKI"
                 }
                 ,
                 {
                 "name":"HOSDURG"
                 }
                 ,
                 {
                 "name":"ERNAKULAM"
                 }
                 ,
                 {
                 "name":"ERNAD"
                 }
                 ,
                 {
                 "name":"DHARMAPURI"
                 }
                 ,
                {
                 "name":"DHARMADOM"
                 }
                 ,
                 {
                 "name":"COIMBATORE"
                 }
                 ,
                 {
                 "name":"COCHIN"
                 }
                 ,
                 {
                 "name":"CHITTOOR"
                 }
                 ,
                 {
                 "name":"CHERTHALA"
                 }
                 ,
                 {
                 "name":"CHERANALLUR"
                 }
                 ,
                 {
                 "name":"CHANGANASSERY"
                 },
                 {
                 "name":"CANNANORE (KANNUR)"
                 },
                 {
                 "name":"CALICUT"
                 },
                 {
                 "name":"BANTWAL"
                 }
                 ,
                 {
                 "name":"ANGAMALI"
                 }
                 ,
                 {
                 "name":"ALUVA"
                 }
                 ,
                 {
                 "name":"ALLEPPEY"
                 }
                 ,
                 {
                 "name":"ALATHUR"
                 }
                 ,
                {
                 "name":"ALAPUZHA"
                 }
                 ,
                 {
                 "name":"ALAPPUZHA"
                 }
               ]
             }},
                  
     {"RAJASTHAN":{
        "city":[{
                 "name":"UKHRUL"
                 },
                 {
                 "name":"THOUBAL"
                 }
                 ,
                 {
                 "name":"TAMENGLONG"
                 }
                 ,
                 {
                 "name":"SUGNU"
                 },
                 {
                 "name":"SENAPATI"
                 },
                 {
                 "name":"MOREH"
                 },
                 {
                 "name":"MOIRANG"
                 }
                 ,
                 {
                 "name":"MAYANG"
                 }
                 ,
                 {
                 "name":"IMPHAL"
                 }
                 ,
                 {
                 "name":"JIRIBAM"
                 }
                 ,
                 {
                 "name":"IMPHAL"
                 }
                 ,
                {
                 "name":"CHURACHANDPUR"
                 }
                 ,
                 {
                 "name":"CHANDEL"
                 }
                 ,
                 {
                 "name":"BISHENPUR"
                 }
               ]
             }},
                  
     {"HIMACHAL PRADESH":{
        "city":[{
                 "name":"UKHRUL"
                 },
                 {
                 "name":"THOUBAL"
                 }
                 ,
                 {
                 "name":"TAMENGLONG"
                 }
                 ,
                 {
                 "name":"SUGNU"
                 },
                 {
                 "name":"SENAPATI"
                 },
                 {
                 "name":"MOREH"
                 },
                 {
                 "name":"MOIRANG"
                 }
                 ,
                 {
                 "name":"MAYANG"
                 }
                 ,
                 {
                 "name":"IMPHAL"
                 }
                 ,
                 {
                 "name":"JIRIBAM"
                 }
                 ,
                 {
                 "name":"IMPHAL"
                 }
                 ,
                {
                 "name":"CHURACHANDPUR"
                 }
                 ,
                 {
                 "name":"CHANDEL"
                 }
                 ,
                 {
                 "name":"BISHENPUR"
                 }
               ]
             }},
                  
     {"DAMAN & DIU":{
        "city":[{
                 "name":"DIU"
                 },
                 {
                 "name":"DAMAN"
                 }
                 
               ]
             }},
                  
     {"UTTAR PRADESH":{
        "city":[{
                 "name":"UKHRUL"
                 },
                 {
                 "name":"THOUBAL"
                 }
                 ,
                 {
                 "name":"TAMENGLONG"
                 }
                 ,
                 {
                 "name":"SUGNU"
                 },
                 {
                 "name":"SENAPATI"
                 },
                 {
                 "name":"MOREH"
                 },
                 {
                 "name":"MOIRANG"
                 }
                 ,
                 {
                 "name":"MAYANG"
                 }
                 ,
                 {
                 "name":"IMPHAL"
                 }
                 ,
                 {
                 "name":"JIRIBAM"
                 }
                 ,
                 {
                 "name":"IMPHAL"
                 }
                 ,
                {
                 "name":"CHURACHANDPUR"
                 }
                 ,
                 {
                 "name":"CHANDEL"
                 }
                 ,
                 {
                 "name":"BISHENPUR"
                 }
               ]
             }},
                  
     {"ARUNACHAL PRADESH":{
        "city":[{
                 "name":"ZIRO"
                 },
                 {
                 "name":"YINGKIONG"
                 }
                 ,
                 {
                 "name":"TEZU"
                 }
                 ,
                 {
                 "name":"ROING"
                 },
                 {
                 "name":"PASIGHAT"
                 },
                 {
                 "name":"NAMSAI"
                 },
                 {
                 "name":"KHONSA"
                 }
                 ,
                 {
                 "name":"JAIRAMPUR"
                 }
                 ,
                 {
                 "name":"ITANAGAR"
                 }
                 ,
                 {
                 "name":"DAPORIJO"
                 }
                 ,
                 {
                 "name":"CHANGLANG"
                 }
                 ,
                {
                 "name":"BOMDILA"
                 }
                 ,
                 {
                 "name":"BASAR"
                 }
                 ,
                 {
                 "name":"ALONG"
                 }
               ]
             }},
                  
     {"CHANDIGARH":{
        "city":[{
                 "name":"CHANDIGARH"
                }
               ]
             }},
                  
     {"WEST BENGAL":{
        "city":[{
                 "name":"UKHRUL"
                 },
                 {
                 "name":"THOUBAL"
                 }
                 ,
                 {
                 "name":"TAMENGLONG"
                 }
                 ,
                 {
                 "name":"SUGNU"
                 },
                 {
                 "name":"SENAPATI"
                 },
                 {
                 "name":"MOREH"
                 },
                 {
                 "name":"MOIRANG"
                 }
                 ,
                 {
                 "name":"MAYANG"
                 }
                 ,
                 {
                 "name":"IMPHAL"
                 }
                 ,
                 {
                 "name":"JIRIBAM"
                 }
                 ,
                 {
                 "name":"IMPHAL"
                 }
                 ,
                {
                 "name":"CHURACHANDPUR"
                 }
                 ,
                 {
                 "name":"CHANDEL"
                 }
                 ,
                 {
                 "name":"BISHENPUR"
                 }
               ]
             }},
                      
     {"LAKSHADWEEP":{
        "city":[{
                 "name":"LAKSHDWEEP"
                 }	         
               ]
             }},
    {"PUNJAB":{
        "city":[{
                 "name":"UKHRUL"
                 },
                 {
                 "name":"THOUBAL"
                 }
                 ,
                 {
                 "name":"TAMENGLONG"
                 }
                 ,
                 {
                 "name":"SUGNU"
                 },
                 {
                 "name":"SENAPATI"
                 },
                 {
                 "name":"MOREH"
                 },
                 {
                 "name":"MOIRANG"
                 }
                 ,
                 {
                 "name":"MAYANG"
                 }
                 ,
                 {
                 "name":"IMPHAL"
                 }
                 ,
                 {
                 "name":"JIRIBAM"
                 }
                 ,
                 {
                 "name":"IMPHAL"
                 }
                 ,
                {
                 "name":"CHURACHANDPUR"
                 }
                 ,
                 {
                 "name":"CHANDEL"
                 }
                 ,
                 {
                 "name":"BISHENPUR"
                 }
               ]
             }},
             
    {"JHARKHAND":{
        "city":[{
                 "name":"WANKANER"
                 },
                 {
                 "name":"VYARA"
                 }
                 ,
                 {
                 "name":"VISNAGAR"
                 }
                 ,
                 {
                 "name":"VISAVADAR"
                 },
                 {
                 "name":"VIRAMGAM"
                 },
                 {
                 "name":"VIJAPUR"
                 },
                 {
                 "name":"VERAVAL"
                 }
                 ,
                 {
                 "name":"VEJALPUR"
                 }
                 ,
                 {
                 "name":"VARTEJ"
                 }
                 ,
                 {
                 "name":"VAPI"
                 }
                 ,
                 {
                 "name":"VANSDA"
                 }
                 ,
                {
                 "name":"VALSAD"
                 }
                 ,
                 {
                 "name":"VADODARA"
                 }
                 ,
                 {
                 "name":"VADIA"
                 },
                 {
                 "name":"UPLETA"
                 }
                 ,
                 {
                 "name":"UNJHA"
                 }
                 ,
                 {
                 "name":"UNA"
                 },
                 {
                 "name":"UMRETH"
                 },
                 {
                 "name":"UMARGAM"
                 },
                 {
                 "name":"THE DANGS"
                 }
                 ,
                 {
                 "name":"THARAD"
                 }
                 ,
                 {
                 "name":"THANGADH"
                 }
                 ,
                 {
                 "name":"TALOD"
                 }
                 ,
                 {
                 "name":"TALAJA"
                 }
                 ,
                {
                 "name":"SURENDRANAGAR"
                 }
                 ,
                 {
                 "name":"SURAT"
                 }
                 ,
                 {
                 "name":"SONGADH"
                 }
                 ,
                 {
                 "name":"SILVASSA"
                 },
                 {
                 "name":"SIHOR"
                 }
                 ,
                 {
                 "name":"SIDDPUR"
                 }
                 ,
                 {
                 "name":"SAYAN"
                 }
                 ,
                 {
                 "name":"SAVARKUNDLA"
                 }
                 ,
                 {
                 "name":"SATLASANA"
                 }
                 ,
                {
                 "name":"SANTRAMPUR"
                 }
                 ,
                 {
                 "name":"SANKHEDA"
                 }
                 ,
                 {
                 "name":"SANAND"
                 }
                 ,
                 {
                 "name":"SALAYA"
                 }
                 ,
                 {
                 "name":"RANOLI"
                 },
                 {
                 "name":"RAMOL"
                 }
                 ,
                 {
                 "name":"RAJULA"
                 }
                 ,
                 {
                 "name":"RAJPIPLA"
                 }
                 ,
                 {
                 "name":"RAJKOT"
                 }
                 ,
                 {
                 "name":"PRANTIJ"
                 }
                 ,
                {
                 "name":"PORBANDAR"
                 }
                 ,
                 {
                 "name":"PATAN"
                 }
                 ,
                 {
                 "name":"PALGHAT"
                 }
                 ,
                 {
                 "name":"PALEJ"
                 }
                 ,
                 {
                 "name":"PALANPUR"
                 }
                 ,
                 {
                 "name":"ODE"
                 }
                 ,
                 {
                 "name":"NAVSARI"
                 },
                 {
                 "name":"NANDEJ"
                 }
                 ,
                 {
                 "name":"NADIAD"
                 }
                 ,
                 {
                 "name":"MUNDRA"
                 }
                 ,
                 {
                 "name":"MORBI"
                 }
                 ,
                 {
                 "name":"MODASA"
                 }
                 ,
                {
                 "name":"MITHAPUR"
                 }
                 ,
                 {
                 "name":"MEHSANA"
                 }
                 ,
                 {
                 "name":"MEGHRAJ"
                 }
                 ,
                {
                 "name":"MANSA"
                 }
                 ,
                 {
                 "name":"MANGROL"
                 }
                 ,
                 {
                 "name":"MANDVI"
                 }
                 ,
                 {
                 "name":"KUTCH"
                 }
                 ,
                 {
                 "name":"MANDVI"
                 }
                 ,
                 {
                 "name":"MALPUR"
                 }
                 ,
                 {
                 "name":"MAHUDHA"
                 },
                 {
                 "name":"LUNAVADA"
                 }
                 ,
                 {
                 "name":"LIMBDI"
                 }
                 ,
                 {
                 "name":"LATHI"
                 }
                 ,
                 {
                 "name":"KUTCH"
                 }
                 ,
                 {
                 "name":"KOTHAMANGALAM"
                 }
                 ,
                {
                 "name":"KOSAMBA"
                 }
                 ,
                 {
                 "name":"KHERALU"
                 }
                 ,
                 {
                 "name":"KHEDA"
                 }
                 ,
                 {
                 "name":"KHAMBHAT"
                 }
                 ,
                 {
                 "name":"KHAMBHALIA"
                 }
                 ,
                 {
                 "name":"KESHOD"
                 }
                 ,
                 {
                 "name":"KARJAN"
                 },
                 {
                 "name":"KAPADWANJ"
                 }
                 ,
                 {
                 "name":"KANPUR"
                 }
                 ,
                 {
                 "name":"KANODAR"
                 }
                 ,
                 {
                 "name":"KALAVAD"
                 }
                 ,
                 {
                 "name":"KADI"
                 }
                 ,
                {
                 "name":"JUNAGADH"
                 }
                 ,
                 {
                 "name":"JETPUR"
                 }
                 ,
                 {
                 "name":"JASDAN"
                 }
                 ,
                {
                 "name":"JAMNAGAR"
                 }
                 ,
                 {
                 "name":"JAMBUSAR"
                 }
                 ,
                 {
                 "name":"JAM"
                 }
                 ,
                 {
                 "name":"JODHPUR"
                 }
                 ,
                 {
                 "name":"JALALPORE"
                 }
                 ,
                 {
                 "name":"JAFRABAD"
                 }
                 ,
                 {
                 "name":"IDAR"
                 },
                 {
                 "name":"HIMATNAGAR"
                 }
                 ,
                 {
                 "name":"HARIJ"
                 }
                 ,
                 {
                 "name":"HALVAD"
                 }
                 ,
                 {
                 "name":"HALOL"
                 }
                 ,
                 {
                 "name":"GONDAL"
                 }
                 ,
                {
                 "name":"GODHARA"
                 }
                 ,
                 {
                 "name":"GANDHINAGAR"
                 }
                 ,
                 {
                 "name":"GANDEVI"
                 }
                 ,
                 {
                 "name":"DOHAD"
                 }
                 ,
                 {
                 "name":"DIGVIJAYGRAM"
                 }
                 ,
                 {
                 "name":"DHROL"
                 }
                 ,
                 {
                 "name":"DHRANGADHRA"
                 }
                 ,
                 {
                 "name":"DHOLKA"
                 }
                 ,
                 {
                 "name":"DHOLA"
                 },
                 {
                 "name":"DHARAMPUR"
                 }
                 ,
                 {
                 "name":"DHANERA"
                 }
                 ,
                 {
                 "name":"DHANDHUKA"
                 }
                 ,
                 {
                 "name":"DEVSAR"
                 }
                 ,
                 {
                 "name":"DEVGADH"
                 }
                 ,
                {
                 "name":"BARIA"
                 }
                 ,
                 {
                 "name":"DEESA"
                 }
                 ,
                 {
                 "name":"DAMNAGAR"
                 }
                 ,
                 {
                 "name":"DAMAN"
                 }
                 ,
                 {
                 "name":"DAHOD"
                 }
                 ,
                 {
                 "name":"DAHEGAM"
                 }
                 ,
                 {
                 "name":"DABHOI"
                 }
                 ,
                 {
                 "name":"CHORVAD"
                 }
                 ,
                 {
                 "name":"CHIKHLI"
                 }
                 ,
                 {
                 "name":"CHHAYA"
                 }
                 ,
                 {
                 "name":"CHANASMA"
                 },
                 {
                 "name":"CHALTHAN"
                 }
                 ,
                 {
                 "name":"CHALALA"
                 }
                 ,
                 {
                 "name":"CHAKLASI"
                 }
                 ,
                 {
                 "name":"BORSAD"
                 }
                 ,
                 {
                 "name":"BORIAVI"
                 }
                 ,
                {
                 "name":"BODELI"
                 }
                 ,
                 {
                 "name":"BHUJ"
                 }
                 ,
                 {
                 "name":"BHAYAVADAR"
                 }
                  ,
                 {
                 "name":"BHAVNAGAR"
                 }
                 ,
                 {
                 "name":"BHARUCH"
                 }
                 ,
                 {
                 "name":"BHACHAU"
                 }
                 ,
                 {
                 "name":"BECHARAJI"
                 }
                 ,
                 {
                 "name":"BAYAD"
                 }
                 ,
                 {
                 "name":"BAVLA"
                 }
                 ,
                 {
                 "name":"BARODA"
                 }
                 ,
                 {
                 "name":"BARDOLI"
                 }
                 ,
                 {
                 "name":"BALASINOR"
                 },
                 {
                 "name":"BAGASARA"
                 }
                 ,
                 {
                 "name":"BABRA"
                 }
                 ,
                 {
                 "name":"ATUL"
                 }
                 ,
                 {
                 "name":"ANKLESHWAR"
                 }
                 ,
                 {
                 "name":"ANJAR"
                 }
                 ,
                {
                 "name":"ANDADA"
                 }
                 ,
                 {
                 "name":"ANAND"
                 }
                 ,
                 {
                 "name":"AMRELI"
                 }
                 ,
                {
                 "name":"AMBAJI"
                 }
                 ,
                 {
                 "name":"AHMEDABAD"
                 }
                 ,
                 {
                 "name":"ABRAMA"
                 }
    
                 
               ]
             }},
     
     {"MIZORAM":{
        "city":[{
                 "name":"VAIRENGTE"
                 },
                 {
                 "name":"SHERCHIP"
                 }
                 ,
                 {
                 "name":"SAITUAL"
                 }
                 ,
                 {
                 "name":"SAIRANG"
                 },
                 {
                 "name":"LUNGSEN"
                 },
                 {
                 "name":"LUNGLEI"
                 },
                 {
                 "name":"LUNGLEH"
                 }
                 ,
                 {
                 "name":"LAWNGTLAI"
                 }
                 ,
                 {
                 "name":"KOLASIB"
                 }
                 ,
                 {
                 "name":"KHAWZAWL"
                 }
                 ,
                 {
                 "name":"HNAHTHIAL"
                 }
                 ,
                {
                 "name":"DARLAWN"
                 }
                 ,
                 {
                 "name":"CHAMPHAI"
                 }
                 ,
                 {
                 "name":"AIZWAL"
                 }
               ]
             }},
                  
     {"MADHYA PRADESH":{
        "city":[{
                 "name":"UKHRUL"
                 },
                 {
                 "name":"THOUBAL"
                 }
                 ,
                 {
                 "name":"TAMENGLONG"
                 }
                 ,
                 {
                 "name":"SUGNU"
                 },
                 {
                 "name":"SENAPATI"
                 },
                 {
                 "name":"MOREH"
                 },
                 {
                 "name":"MOIRANG"
                 }
                 ,
                 {
                 "name":"MAYANG"
                 }
                 ,
                 {
                 "name":"IMPHAL"
                 }
                 ,
                 {
                 "name":"JIRIBAM"
                 }
                 ,
                 {
                 "name":"IMPHAL"
                 }
                 ,
                {
                 "name":"CHURACHANDPUR"
                 }
                 ,
                 {
                 "name":"CHANDEL"
                 }
                 ,
                 {
                 "name":"BISHENPUR"
                 }
               ]
             }},
                  
     {"MAHARASHTRA":{
        "city":[{
                 "name":"YEOTAMAL"
                 },
                 {
                 "name":"YAWAL"
                 }
                 ,
                 {
                 "name":"YAVATMAL"
                 }
                 ,
                 {
                 "name":"WASHIM"
                 },
                 {
                 "name":"WARUD"
                 },
                 {
                 "name":"WARORA"
                 },
                 {
                 "name":"MOIRANG"
                 }
                 ,
                 {
                 "name":"WANI"
                 }
                 ,
                 {
                 "name":"WAI"
                 }
                 ,
                 {
                 "name":"VITA"
                 }
                 ,
                 {
                 "name":"VIRAR"
                 }
                 ,
                {
                 "name":"VENGURLA"
                 }
                 ,
                 {
                 "name":"VARANGAON"
                 }
                 ,
                 {
                 "name":"VAIJAPUR"
                 }
                 ,
                 {
                 "name":"VADUJ"
                 }
                 ,
                 {
                 "name":"VADGAON"
                 }
                 ,
                 {
                 "name":"VADA"
                 },
                 {
                 "name":"URAN"
                 },
                 {
                 "name":"UNDRI"
                 },
                 {
                 "name":"UMRED"
                 }
                 ,
                 {
                 "name":"ULHASNAGAR"
                 }
                 ,
                 {
                 "name":"TUMSAR"
                 }
                 ,
                 {
                 "name":"TULJAPUR"
                 }
                 ,
                 {
                 "name":"TRIMBAK"
                 }
                 ,
                {
                 "name":"TIRORA"
                 }
                 ,
                 {
                 "name":"THANE"
                 }
                 ,
                 {
                 "name":"TEMBHURNI"
                 }
                 ,
                 {
                 "name":"TELHARA"
                 }
                 ,
                 {
                 "name":"TASGAON"
                 }
                 ,
                 {
                 "name":"TARAPUR"
                 },
                 {
                 "name":"TALEGAON DABHADE"
                 },
                 {
                 "name":"SURGANA"
                 },
                 {
                 "name":"SONPETH"
                 }
                 ,
                 {
                 "name":"SOLAPUR"
                 }
                 ,
                 {
                 "name":"SINNAR"
                 }
                 ,
                 {
                 "name":"SINDKHED RAJA"
                 }
                 ,
                 {
                 "name":"SINDI RAILWAY"
                 }
                 ,
                {
                 "name":"SINDHUDURG"
                 }
                 ,
                 {
                 "name":"SILLOD"
                 }
                 ,
                 {
                 "name":"SHRIVARDHAN"
                 }
                 ,
                 {
                 "name":"SHRIRAMPUR"
                 }
                 ,
                 {
                 "name":"SHRINAGARTALI"
                 }
                 ,
                 {
                 "name":"SHIVAJINAGAR"
                 },
                 {
                 "name":"SHIRVAL"
                 },
                 {
                 "name":"SHIRUR"
                 },
                 {
                 "name":"SHIRPUR"
                 }
                 ,
                 {
                 "name":"SHIRDI"
                 }
                 ,
                 {
                 "name":"SHINDKHEDA"
                 }
                 ,
                 {
                 "name":"SHIKRAPUR"
                 }
                 ,
                 {
                 "name":"SHAHADA"
                 }
                 ,
                {
                 "name":"SAVDA"
                 }
                 ,
                 {
                 "name":"SATARA"
                 }
                 ,
                 {
                 "name":"SATANA"
                 }
                 ,
                 {
                 "name":"SASWAD"
                 }
                 ,
                 {
                 "name":"SASTI"
                 }
                 ,
                 {
                 "name":"SANGOLA"
                 }
                 ,
                 {
                 "name":"SANGLI"
                 }
                 ,
                {
                 "name":"SANGAMNER"
                 }
                 ,
                 {
                 "name":"SAMUDRAPUR"
                 }
                 ,
                 {
                 "name":"SAKRI"
                 }
                 ,
                 {
                 "name":"SAKOLI"
                 }
                 ,
                 {
                 "name":"SAILU"
                 }
                 ,
                 {
                 "name":"ROHA"
                 },
                 {
                 "name":"RISOD"
                 },
                 {
                 "name":"RAVER"
                 },
                 {
                 "name":"RATNAGIRI"
                 }
                 ,
                 {
                 "name":"RAMTEK"
                 }
                 ,
                 {
                 "name":"RAJUR"
                 }
                 ,
                 {
                 "name":"RAJGURUNAGAR"
                 }
                 ,
                 {
                 "name":"RAIPUR"
                 }
                 ,
                {
                 "name":"RAIGARH"
                 }
                 ,
                 {
                 "name":"RAIGAD"
                 }
                 ,
                 {
                 "name":"RAHURI"
                 }
                 ,
                 {
                 "name":"RAHIMATPUR"
                 }
                 ,
                 {
                 "name":"PUSAD"
                 }
                 ,
                 {
                 "name":"PURNA"
                 },
                 {
                 "name":"PUNE"
                 },
                 {
                 "name":"PULGAON"
                 },
                 {
                 "name":"POLADPUR"
                 }
                 ,
                 {
                 "name":"PIMPRI CHINCHWAD"
                 }
                 ,
                 {
                 "name":"PIMPALGAON"
                 }
                 ,
                 {
                 "name":"PHALTAN"
                 }
                 ,
                 {
                 "name":"PEN"
                 }
                 ,
                {
                 "name":"PAVANI"
                 }
                 ,
                 {
                 "name":"PATUR"
                 }
                 ,
                 {
                 "name":"PATHRI"
                 }
                 ,
                 {
                 "name":"PATHARDI"
                 },
                 {
                 "name":"PATAN"
                 },
                 {
                 "name":"PARTUR"
                 },
                 {
                 "name":"PARLI VAIJNATH"
                 }
                 ,
                 {
                 "name":"PARBHANI"
                 }
                 ,
                 {
                 "name":"PARANDA"
                 }
                 ,
                 {
                 "name":"PANHALA"
                 }
                 ,
                 {
                 "name":"PANDHARPUR"
                 }
                 ,
                {
                 "name":"PANDHARAKWADA"
                 }
                 ,
                 {
                 "name":"PAITHAN"
                 }
                 ,
                 {
                 "name":"PADAGHA"
                 }
                 ,
                 {
                 "name":"PACHORA"
                 }
                 ,
                 {
                 "name":"OZAR"
                 }
                 ,
                 {
                 "name":"OSMANABAD"
                 },
                 {
                 "name":"ORAS"
                 },
                 {
                 "name":"NERAL"
                 },
                 {
                 "name":"NER"
                 }
                 ,
                 {
                 "name":"NAVI MUMBAI"
                 }
                 ,
                 {
                 "name":"NATEPUTE"
                 }
                 ,
                 {
                 "name":"NASIK"
                 }
                 ,
                 {
                 "name":"NARAYANGAON"
                 }
                 ,
                {
                 "name":"NANDURBAR"
                 }
                 ,
                 {
                 "name":"NANDURA"
                 }
                 ,
                 {
                 "name":"NANDGAON"
                 }
                 ,
                 {
                 "name":"NANDED"
                 }
                 ,
                 {
                 "name":"NALDURG"
                 }
                 ,
                 {
                 "name":"NAGPUR"
                 },
                 {
                 "name":"NAGOTHANA"
                 },
                 {
                 "name":"MURUD"
                 },
                 {
                 "name":"MURTAJAPUR"
                 }
                 ,
                 {
                 "name":"MURGUD"
                 }
                 ,
                 {
                 "name":"MURBAD"
                 }
                 ,
                 {
                 "name":"MUMBAI"
                 }
                 ,
                 {
                 "name":"MUL"
                 }
                 ,
                {
                 "name":"MUKUTBAN"
                 }
                 ,
                 {
                 "name":"MUKHED"
                 }
                 ,
                 {
                 "name":"MOWAD"
                 }
                 ,
                 {
                 "name":"MOUDA"
                 }
                 ,
                 {
                 "name":"MORSHI"
                 }
                 ,
                 {
                 "name":"MOHPA"
                 },
                 {
                 "name":"MOHOPADA"
                 },
                 {
                 "name":"MOHOL"
                 },
                 {
                 "name":"MHASVAD"
                 }
                 ,
                 {
                 "name":"MATHERAN"
                 }
                 ,
                 {
                 "name":"MANWATH"
                 }
                 ,
                 {
                 "name":"MANSAR"
                 }
                 ,
                 {
                 "name":"MANOR"
                 }
                 ,
                {
                 "name":"MANMAD"
                 }
                 ,
                 {
                 "name":"MANGRULPIR"
                 }
                 ,
                 {
                 "name":"MANGAON"
                 }
                 ,
                 {
                 "name":"MALSHIRAS"
                 }
                 ,
                 {
                 "name":"MALPUR"
                 }
                 ,
                 {
                 "name":"MALKAPUR"
                 }
                 ,
                 {
                 "name":"MALEGAON"
                 }
                 ,
                {
                 "name":"MAINDARGI"
                 }
                 ,
                 {
                 "name":"MAHAD"
                 }
                 ,
                 {
                 "name":"MAHABALESHWAR"
                 }
                 ,
                 {
                 "name":"LONI BK"
                 }
                 ,
                 {
                 "name":"LONAVALA"
                 }
                 ,
                 {
                 "name":"LONAR"
                 },
                 {
                 "name":"LONAND"
                 },
                 {
                 "name":"LOHA"
                 },
                 {
                 "name":"LATUR"
                 }
                 ,
                 {
                 "name":"LASALGAON"
                 }
                 ,
                 {
                 "name":"KURUNDVAD"
                 }
                 ,
                 {
                 "name":"KURUDWADI"
                 }
                 ,
                 {
                 "name":"KUNDALWADI"
                 }
                 ,
                {
                 "name":"KUDAL"
                 }
                 ,
                 {
                 "name":"KOREGAON"
                 }
                 ,
                 {
                 "name":"KOPERGAON"
                 }
                 ,
                 {
                 "name":"KOLHAPUR"
                 }
                 ,
                 {
                 "name":"KODOLI"
                 }
                 ,
                 {
                 "name":"KINWAT"
                 },
                 {
                 "name":"KHULDABAD"
                 },
                 {
                 "name":"KHOPOLI"
                 },
                 {
                 "name":"KHERDI"
                 }
                 ,
                 {
                 "name":"KHED"
                 }
                 ,
                 {
                 "name":"KHAMGAON"
                 }
                 ,
                 {
                 "name":"KHALAPUR"
                 }
                 ,
                 {
                 "name":"KATOL"
                 }
                 ,
                {
                 "name":"KATNI"
                 }
                 ,
                 {
                 "name":"KARJAT"
                 }
                 ,
                 {
                 "name":"KARANJA GHADGE"
                 }
                 ,
                 {
                 "name":"KARANJA"
                 },
                 {
                 "name":"KARAMALA"
                 },
                 {
                 "name":"KARAD"
                 },
                 {
                 "name":"KANNAD"
                 }
                 ,
                 {
                 "name":"KAMSHET"
                 }
                 ,
                 {
                 "name":"KAMPTEE"
                 }
                 ,
                 {
                 "name":"KALWAN"
                 }
                 ,
                 {
                 "name":"KALMESHWAR"
                 }
                 ,
                {
                 "name":"KALAMNURI"
                 }
                 ,
                 {
                 "name":"KALAMB"
                 }
                 ,
                 {
                 "name":"KAGAL"
                 }
                 ,
                 {
                 "name":"JUNNAR"
                 }
                 ,
                 {
                 "name":"JINTUR"
                 }
                 ,
                 {
                 "name":"JALNA"
                 },
                 {
                 "name":"JALGAON JAMOD"
                 },
                 {
                 "name":"JALGAON"
                 },
                 {
                 "name":"ISLAMPUR"
                 }
                 ,
                 {
                 "name":"INDORE"
                 }
                 ,
                 {
                 "name":"INDAPUR"
                 }
                 ,
                 {
                 "name":"IGATPURI"
                 }
                 ,
                 {
                 "name":"ICHALKARANJI"
                 }
                 ,
                {
                 "name":"HOOGHLY"
                 }
                 ,
                 {
                 "name":"HINGOLI"
                 }
                 ,
                 {
                 "name":"HINGANGHAT"
                 }
                  ,
                 {
                 "name":"HADGAON"
                 }
                 ,
                 {
                 "name":"GUHAGAR"
                 }
                 ,
                 {
                 "name":"GOREGAON"
                 }
                 ,
                {
                 "name":"GONDIA"
                 }
                 ,
                 {
                 "name":"GHUGUS"
                 }
                 ,
                 {
                 "name":"GHOTI"
                 }
                 ,
                 {
                 "name":"GANGAKHED"
                 }
                 ,
                 {
                 "name":"GADHINGLAJ"
                 }
                 ,
                 {
                 "name":"GADCHIROLI"
                 },
                 {
                 "name":"FAIZPUR"
                 },
                 {
                 "name":"ERANDOL"
                 },
                 {
                 "name":"DUDHANI"
                 }
                 ,
                 {
                 "name":"DONDAICHA"
                 }
                 ,
                 {
                 "name":"DINDORI MH"
                 }
                 ,
                 {
                 "name":"DIGRAS"
                 }
                 ,
                 {
                 "name":"DHULE"
                 }
                 ,
                {
                 "name":"DHARMABAD"
                 }
                 ,
                 {
                 "name":"DHARANGAON"
                 }
                 ,
                 {
                 "name":"DEOLALI"
                 }
                 ,
                 {
                 "name":"DAUND"
                 }
                 ,
                 {
                 "name":"DARYAPUR"
                 }
                 ,
                 {
                 "name":"DARWHA"
                 }
                 ,
                {
                 "name":"DAPOLI"
                 }
                 ,
                 {
                 "name":"DAHANU MH"
                 }
                 ,
                 {
                 "name":"CHOPDA"
                 }
                 ,
                 {
                 "name":"CHIPLUN"
                 }
                 ,
                 {
                 "name":"CHINCHANI"
                 }
                 ,
                 {
                 "name":"CHIMUR"
                 },
                 {
                 "name":"CHIKHLI"
                 },
                 {
                 "name":"CHIKHALDARA"
                 },
                 {
                 "name":"CHANDUR"
                 }
                 ,
                 {
                 "name":"RAILWAY"
                 }
                 ,
                 {
                 "name":"CHANDRAPUR"
                 }
                 ,
                 {
                 "name":"CHALISGAON"
                 }
                 ,
                 {
                 "name":"CHAKUR"
                 }
                 ,
                {
                 "name":"BULDHANA"
                 }
                 ,
                 {
                 "name":"BUDHGAON"
                 }
                 ,
                 {
                 "name":"BODVAD"
                 }
                  ,
                 {
                 "name":"BHOKARDAN"
                 }
                 ,
                 {
                 "name":"BHIGWAN"
                 }
                 ,
                 {
                 "name":"BHANDARA"
                 },
                 {
                 "name":"BHAGUR"
                 },
                 {
                 "name":"BHADRAVATI"
                 },
                 {
                 "name":"BEED"
                 }
                 ,
                 {
                 "name":"BASMAT"
                 }
                 ,
                 {
                 "name":"BARSHI"
                 }
                 ,
                 {
                 "name":"BARAMATI"
                 }
                 ,
                 {
                 "name":"BALLARPUR"
                 }
                 ,
                {
                 "name":"AURANGABAD"
                 }
                 ,
                 {
                 "name":"ASHTI"
                 }
                 ,
                 {
                 "name":"ARVI"
                 }
                      ,
                 {
                 "name":"ARNI"
                 }
                 ,
                 {
                 "name":"ANJANGAON"
                 },
                 {
                 "name":"AMRAVATI"
                 },
                 {
                 "name":"AMGAON"
                 },
                 {
                 "name":"AMALNER"
                 }
                 ,
                 {
                 "name":"ALIBAUG"
                 }
                 ,
                 {
                 "name":"AKOT"
                 }
                 ,
                 {
                 "name":"AKOLA"
                 }
                 ,
                 {
                 "name":"AKLUJ"
                 }
                 ,
                {
                 "name":"AKKALKOT"
                 }
                 ,
                 {
                 "name":"AJRA"
                 }
                 ,
                 {
                 "name":"AHMEDNAGAR"
                 }
               ]
             }},
                  
     {"ASSAM":{
        "city":[{
                 "name":"UKHRUL"
                 },
                 {
                 "name":"THOUBAL"
                 }
                 ,
                 {
                 "name":"TAMENGLONG"
                 }
                 ,
                 {
                 "name":"SUGNU"
                 },
                 {
                 "name":"SENAPATI"
                 },
                 {
                 "name":"MOREH"
                 },
                 {
                 "name":"MOIRANG"
                 }
                 ,
                 {
                 "name":"MAYANG"
                 }
                 ,
                 {
                 "name":"IMPHAL"
                 }
                 ,
                 {
                 "name":"JIRIBAM"
                 }
                 ,
                 {
                 "name":"IMPHAL"
                 }
                 ,
                {
                 "name":"CHURACHANDPUR"
                 }
                 ,
                 {
                 "name":"CHANDEL"
                 }
                 ,
                 {
                 "name":"BISHENPUR"
                 }
               ]
             }},
                  
     {"HARYANA":{
        "city":[{
                 "name":"UKHRUL"
                 },
                 {
                 "name":"THOUBAL"
                 }
                 ,
                 {
                 "name":"TAMENGLONG"
                 }
                 ,
                 {
                 "name":"SUGNU"
                 },
                 {
                 "name":"SENAPATI"
                 },
                 {
                 "name":"MOREH"
                 },
                 {
                 "name":"MOIRANG"
                 }
                 ,
                 {
                 "name":"MAYANG"
                 }
                 ,
                 {
                 "name":"IMPHAL"
                 }
                 ,
                 {
                 "name":"JIRIBAM"
                 }
                 ,
                 {
                 "name":"IMPHAL"
                 }
                 ,
                {
                 "name":"CHURACHANDPUR"
                 }
                 ,
                 {
                 "name":"CHANDEL"
                 }
                 ,
                 {
                 "name":"BISHENPUR"
                 }
               ]
             }},
                  
     {"TAMILNADU":{
        "city":[{
                 "name":"UKHRUL"
                 },
                 {
                 "name":"THOUBAL"
                 }
                 ,
                 {
                 "name":"TAMENGLONG"
                 }
                 ,
                 {
                 "name":"SUGNU"
                 },
                 {
                 "name":"SENAPATI"
                 },
                 {
                 "name":"MOREH"
                 },
                 {
                 "name":"MOIRANG"
                 }
                 ,
                 {
                 "name":"MAYANG"
                 }
                 ,
                 {
                 "name":"IMPHAL"
                 }
                 ,
                 {
                 "name":"JIRIBAM"
                 }
                 ,
                 {
                 "name":"IMPHAL"
                 }
                 ,
                {
                 "name":"CHURACHANDPUR"
                 }
                 ,
                 {
                 "name":"CHANDEL"
                 }
                 ,
                 {
                 "name":"BISHENPUR"
                 }
               ]
             }},
                  
     {"SIKKIM":{
        "city":[{
                 "name":"SINGTAM"
                 },
                 {
                 "name":"RANGPO"
                 }
                 ,
                 {
                 "name":"NAYABAZAR"
                 }
                 ,
                 {
                 "name":"NAMCHI"
                 },
                 {
                 "name":"MANGAN"
                 },
                 {
                 "name":"GYALSHING"
                 },
                 {
                 "name":"GANGTOK"
                 }
               ]
             }},
                  
     {"NAGALAND":{
        "city":[{
                 "name":"ZUNEHBOTO"
                 },
                 {
                 "name":"WOKHA"
                 }
                 ,
                 {
                 "name":"TUENGSANG"
                 }
                 ,
                 {
                 "name":"PHEK"
                 },
                 {
                 "name":"MON"
                 },
                 {
                 "name":"MOKOKCHUNG"
                 },
                 {
                 "name":"KOHIMA"
                 }
                 ,
                 {
                 "name":"DIMAPUR"
                 }
                 ,
                 {
                 "name":"CHUMUKHEDIMA"
                 }
                 ,
                 {
                 "name":"CHUKITONG"
                 }
                 ,
                 {
                 "name":"IMPHAL"
                 }
               ]
             }},
                  
     {"ANDHRA PRADESH":{
        "city":[{
                 "name":"UKHRUL"
                 },
                 {
                 "name":"THOUBAL"
                 }
                 ,
                 {
                 "name":"TAMENGLONG"
                 }
                 ,
                 {
                 "name":"SUGNU"
                 },
                 {
                 "name":"SENAPATI"
                 },
                 {
                 "name":"MOREH"
                 },
                 {
                 "name":"MOIRANG"
                 }
                 ,
                 {
                 "name":"MAYANG"
                 }
                 ,
                 {
                 "name":"IMPHAL"
                 }
                 ,
                 {
                 "name":"JIRIBAM"
                 }
                 ,
                 {
                 "name":"IMPHAL"
                 }
                 ,
                {
                 "name":"CHURACHANDPUR"
                 }
                 ,
                 {
                 "name":"CHANDEL"
                 }
                 ,
                 {
                 "name":"BISHENPUR"
                 },
                 {
                  "name":"VISAKHAPATNAM"
                }
               ]
             }},
                  
     {"BIHAR":{
        "city":[{
                 "name":"UKHRUL"
                 },
                 {
                 "name":"THOUBAL"
                 }
                 ,
                 {
                 "name":"TAMENGLONG"
                 }
                 ,
                 {
                 "name":"SUGNU"
                 },
                 {
                 "name":"SENAPATI"
                 },
                 {
                 "name":"MOREH"
                 },
                 {
                 "name":"MOIRANG"
                 }
                 ,
                 {
                 "name":"MAYANG"
                 }
                 ,
                 {
                 "name":"IMPHAL"
                 }
                 ,
                 {
                 "name":"JIRIBAM"
                 }
                 ,
                 {
                 "name":"IMPHAL"
                 }
                 ,
                {
                 "name":"CHURACHANDPUR"
                 }
                 ,
                 {
                 "name":"CHANDEL"
                 }
                 ,
                 {
                 "name":"BISHENPUR"
                 }
               ]
             }},
                  
     {"UTTARANCHAL":{
        "city":[{
                 "name":"UKHRUL"
                 },
                 {
                 "name":"THOUBAL"
                 }
                 ,
                 {
                 "name":"TAMENGLONG"
                 }
                 ,
                 {
                 "name":"SUGNU"
                 },
                 {
                 "name":"SENAPATI"
                 },
                 {
                 "name":"MOREH"
                 },
                 {
                 "name":"MOIRANG"
                 }
                 ,
                 {
                 "name":"MAYANG"
                 }
                 ,
                 {
                 "name":"IMPHAL"
                 }
                 ,
                 {
                 "name":"JIRIBAM"
                 }
                 ,
                 {
                 "name":"IMPHAL"
                 }
                 ,
                {
                 "name":"CHURACHANDPUR"
                 }
                 ,
                 {
                 "name":"CHANDEL"
                 }
                 ,
                 {
                 "name":"BISHENPUR"
                 }
               ]
             }},
                  
     {"PONDICHERRY":{
        "city":[{
                 "name":"YANAM"
                 },
                 {
                 "name":"VILLUPPURAM"
                 }
                 ,
                 {
                 "name":"PONDICHERRY"
                 }
                 ,
                 {
                 "name":"MAHE"
                 },
                 {
                 "name":"KARAIKAL"
                 }
               ]
             }},
                  
     {"TRIPURA":{
        "city":[{
                 "name":"TELIAMURA"
                 },
                 {
                 "name":"SABROOM"
                 }
                 ,
                 {
                 "name":"RANIRBAZAR"
                 }
                 ,
                 {
                 "name":"KUNJABAN"
                 },
                 {
                 "name":"KUMARGHAT"
                 },
                 {
                 "name":"KHOWAI"
                 },
                 {
                 "name":"KANCHANPUR"
                 }
                 ,
                 {
                 "name":"KAMALPUR"
                 }
                 ,
                 {
                 "name":"KAILASHAHAR"
                 }
                 ,
                 {
                 "name":"JOGENDRANAGAR"
                 }
                 ,
                 {
                 "name":"DHARMA NAGAR"
                 }
                 ,
                {
                 "name":"BELONIYA"
                 }
                 ,
                 {
                 "name":"AMBASSA"
                 }
                 ,
                 {
                 "name":"AMARPUR"
                 }
                 ,
                 {
                 "name":"AGARTALA"
                 }
               ]
             }},
                      
     {"MEGHALAYA":{
        "city":[{
                 "name":"WILLIAMNAGAR"
                 },
                 {
                 "name":"TURA"
                 }
                 ,
                 {
                 "name":"SHILLONG"
                 }
                 ,
                 {
                 "name":"RESUBELPARA"
                 },
                 {
                 "name":"NONGTHYMMAI"
                 },
                 {
                 "name":"NONGSTOIN"
                 },
                 {
                 "name":"NONGPOH"
                 }
                 ,
                 {
                 "name":"MADANRITTING"
                 }
                 ,
                 {
                 "name":"JOWAI"
                 }
                 ,
                 {
                 "name":"JAIAW"
                 }
                 ,
                 {
                 "name":"CHERRAPUNJEE"
                 }
                 ,
                {
                 "name":"BAGHMARA"
                 }
               ]
             }},
        
     {"JAMMU AND KASHMIR":{
        "city":[{
                 "name":"VIJAY PUR"
                 },
                 {
                 "name":"URI"
                 }
                 ,
                 {
                 "name":"UDHAMPUR"
                 }
                 ,
                 {
                 "name":"TRAL"
                 },
                 {
                 "name":"SUNDERBANI"
                 },
                 {
                 "name":"SUMBAL"
                 },
                 {
                 "name":"SRINAGAR"
                 }
                 ,
                 {
                 "name":"SAMBA"
                 }
                 ,
                 {
                 "name":"REASI"
                 }
                 ,
                 {
                 "name":"RANBIRSINGHPORA"
                 }
                 ,
                 {
                 "name":"RAMBAN"
                 }
                 ,
                {
                 "name":"RAJOURI"
                 }
                 ,
                 {
                 "name":"QAZIGUND"
                 }
                 ,
                 {
                 "name":"PULWANA"
                 },
                 {
                 "name":"PULWAMA"
                 },
                 {
                 "name":"POONCH"
                 }
                 ,
                 {
                 "name":"PATTAN"
                 }
                 ,
                 {
                 "name":"PAROLE"
                 },
                 {
                 "name":"MAGAM"
                 },
                 {
                 "name":"LEH"
                 },
                 {
                 "name":"KUPWARA"
                 }
                 ,
                 {
                 "name":"KUNZER"
                 }
                 ,
                 {
                 "name":"KULGAM"
                 }
                 ,
                 {
                 "name":"KUD"
                 }
                 ,
                 {
                 "name":"KISHTWAR"
                 }
                 ,
                {
                 "name":"KHREW"
                 }
                 ,
                 {
                 "name":"KHOUR"
                 }
                 ,
                 {
                 "name":"KATRA"
                 }
                  ,
                 {
                 "name":"KATHUA"
                 },
                 {
                 "name":"KARGIL"
                 },
                 {
                 "name":"JOURIAN"
                 }
                 ,
                 {
                 "name":"JAMMU"
                 }
                 ,
                 {
                 "name":"HANDWARA"
                 },
                 {
                 "name":"HAJAN"
                 },
                 {
                 "name":"GULMARG"
                 },
                 {
                 "name":"GANDERBAL"
                 }
                 ,
                 {
                 "name":"DODA"
                 }
                 ,
                 {
                 "name":"CHENANI"
                 }
                 ,
                 {
                 "name":"BIJBEHARA"
                 }
                 ,
                 {
                 "name":"BEERWAH"
                 }
                 ,
                {
                 "name":"BATOTE"
                 }
                 ,
                 {
                 "name":"BARAMULLA"
                 }
                 ,
                 {
                 "name":"BANIHAL"
                 }
                 ,
                 {
                 "name":"BADGAM"
                 }
                 ,
                 {
                 "name":"AWANTIPORA"
                 }
                 ,
                {
                 "name":"ARNIA"
                 }
                 ,
                 {
                 "name":"ANANTNAG"
                 }
                 ,
                 {
                 "name":"ACHABAL"
                 }
               ]
             }},
                  
     {"DELHI":{
        "city":[
                 {
                 "name":"SONEPAT"
                 }
                 ,
                 {
                 "name":"SOLAN"
                 },
                 {
                 "name":"ROHTAK"
                 },
                 {
                 "name":"NEW DELHI"
                 },
                 {
                 "name":"MEERUT"
                 }
                 ,
                 {
                 "name":"FARUKHABAD"
                 }
                 ,
                 {
                 "name":"FARIDABAD"
                 }
                 ,
                 {
                 "name":"DELHI"
                 }
                 ,
                 {
                 "name":"BAGHPAT"
                 }
                 ,
                {
                 "name":"AMBALA"
                 }
               ]
             }},
                  
     {"ORISSA":{
        "city":[{
                 "name":"UDALA"
                 },
                 {
                 "name":"TENSA"
                 }
                 ,
                 {
                 "name":"TALCHER"
                 }
                 ,
                 {
                 "name":"SUNDARGARH"
                 },
                 {
                 "name":"SORO"
                 },
                 {
                 "name":"SONAPUR"
                 },
                 {
                 "name":"SIMULIA"
                 }
                 ,
                 {
                 "name":"SAMBALPUR"
                 }
                 ,
                 {
                 "name":"ROURKELA"
                 }
                 ,
                 {
                 "name":"REMUNA"
                 }
                 ,
                 {
                 "name":"RAYAGADA"
                 }
                 ,
                {
                 "name":"RAMBHA"
                 }
                 ,
                 {
                 "name":"RAIRANGPUR"
                 }
                 ,
                 {
                 "name":"PURUSOTTAMPUR"
                 },
                 {
                 "name":"PURI"
                 },
                 {
                 "name":"PHULBANI"
                 }
                 ,
                 {
                 "name":"PATTAMUNDAI"
                 }
                 ,
                 {
                 "name":"PATNAGARH"
                 },
                 {
                 "name":"PARLAKHEMUNDI"
                 },
                 {
                 "name":"PANIKOII"
                 },
                 {
                 "name":"PADMAPUR"
                 }
                 ,
                 {
                 "name":"NUAPATNA"
                 }
                 ,
                 {
                 "name":"NAYAGARH"
                 }
                 ,
                 {
                 "name":"NAUPADA"
                 }
                 ,
                 {
                 "name":"NABEEN"
                 }
                 ,
                {
                 "name":"NABARANGAPUR"
                 }
                 ,
                 {
                 "name":"MUKHIGUDA"
                 }
                 ,
                 {
                 "name":"MALKANGIRI"
                 }
                 ,
                 {
                 "name":"KOTPAD"
                 },
                 {
                 "name":"KORDHA"
                 }
                 ,
                 {
                 "name":"KORAPUT"
                 }
                 ,
                 {
                 "name":"KONARK"
                 }
                 ,
                 {
                 "name":"KODALA"
                 }
                 ,
                 {
                 "name":"KHURDHA"
                 }
                 ,
                {
                 "name":"KESINGA"
                 }
                 ,
                 {
                 "name":"KEONJHAR"
                 }
                 ,
                 {
                 "name":"KENDUJHAR"
                 },
                 {
                 "name":"KENDRAPARA"
                 },
                 {
                 "name":"KENDRAPADA"
                 }
                 ,
                 {
                 "name":"KARANJIA"
                 }
                 ,
                 {
                 "name":"KANTILO"
                 },
                 {
                 "name":"KANTABANJI"
                 },
                 {
                 "name":"KANDHAMAL"
                 },
                 {
                 "name":"KALAHANDI"
                 }
                 ,
                 {
                 "name":"JUNAGARH"
                 }
                 ,
                 {
                 "name":"JODA"
                 }
                 ,
                 {
                 "name":"JHUMPURA"
                 }
                 ,
                 {
                 "name":"JHARSUGUDA"
                 }
                 ,
                {
                 "name":"JALDA"
                 }
                 ,
                 {
                 "name":"JAGATSINGHAPUR"
                 }
                 ,
                 {
                 "name":"HOOGHLY"
                 }
                 ,
                 {
                 "name":"HIRAKUD"
                 }
                 ,
                 {
                 "name":"GUNUPUR"
                 }
                 ,
                 {
                 "name":"GUDARI"
                 }
                 ,
                {
                 "name":"GOPALPUR"
                 }
                 ,
                 {
                 "name":"GANJAM"
                 }
                 ,
                 {
                 "name":"DIGAPAHANDI"
                 },
                 {
                 "name":"DHENKANAL"
                 },
                 {
                 "name":"DEBAGARH"
                 }
                 ,
                 {
                 "name":"DAMANJODI"
                 }
                 ,
                 {
                 "name":"CUTTACK"
                 },
                 {
                 "name":"CHATRAPUR"
                 },
                 {
                 "name":"CHAMPUA"
                 },
                 {
                 "name":"BUGUDA"
                 }
                 ,
                 {
                 "name":"BOLANGIR"
                 }
                 ,
                 {
                 "name":"BHUBANESWAR"
                 }
                 ,
                 {
                 "name":"BHUBAN"
                 }
                 ,
                 {
                 "name":"BHAWANESHWAR"
                 }
                 ,
                {
                 "name":"BHADRAK"
                 }
                 ,
                 {
                 "name":"BERHAMPUR"
                 }
                 ,
                 {
                 "name":"BERHAMPORE"
                 }
                 ,
                 {
                 "name":"BELPAHAR"
                 },
                 {
                 "name":"BAUDH"
                 }
                 ,
                 {
                 "name":"BASUDEBPUR"
                 }
                 ,
                 {
                 "name":"BARIPARA"
                 }
                 ,
                 {
                 "name":"BARGARH"
                 }
                 ,
                 {
                 "name":"BALUGAON"
                 }
                 ,
                {
                 "name":"BALIMELA"
                 }
                 ,
                 {
                 "name":"BALESHWAR"
                 }
                 ,
                 {
                 "name":"BALASORE"
                 },
                 {
                 "name":"ATHMALLIK"
                 },
                 {
                 "name":"ANUGUL"
                 }
                 ,
                 {
                 "name":"ANANDAPUR"
                 }
               ]
             }},
                      
     {"ANDAMAN & NICOBAR":{
        "city":[{
                 "name":"PORT BLAIR "
                 },
                 {
                 "name":"CAR NICOBAR"
                 }
                 
               ]
             }},
        
]
// console.log("test ",cityStateList)
// for(let d in cityStateList){
//     console.log("data ",d); // It gives you property name
//     console.log("citylist",cityStateList[d]);
//     let  cityList =   // And this gives you its value
// }

// Object.entries(cityStateList).forEach(
//     ([key, value]) => console.log("data is ",key, value)
// );

// for (const [key, value] of Object.entries(cityStateList)) {
//     console.log("keyname" , `${key}: ${value}`);
//   }


// for (var key in cityStateList) {
//     if (cityStateList.hasOwnProperty(key)) {
//       var val = cityStateList[key];
//       console.log("statename",val)
//       for (var key in val) {
//         if (val.hasOwnProperty(key)) {
//           var dialog = val[key];
//           console.log("cityname",dialog.city);
//         }
//       }
//     }
// }